module.exports = __webpack_public_path__ + "static/media/sell_help_10a.9067055e.png";